import i18next from '@fintronners/react-language/src/Lang';

export const orderDisplayStrings = {
  partialFill: i18next.t('common.partialFill'),
  automatedInvestment: i18next.t('common.automatedInvestment'),
  trade: i18next.t('common.trade'),
  partialFillSuffix: (type: string, context?: 'visible') =>
    i18next.t('miscScreens.activityHistory.popups.partialFillSuffix', { type, context }),
  orderType: i18next.t('miscScreens.tradeDisplay.tradeOrderTypeLabel'),
  orderTypes: i18next.t('miscScreens.tradeDisplay.tradeScreenOrderTypesInfoTitle'),
  orderDuration: i18next.t('miscScreens.tradeDisplay.tradeOrderOrderDuration'),
  oneDay: i18next.t('miscScreens.tradeDisplay.tradeOrderLimitOneDay'),
  goodForOneDay: i18next.t('miscScreens.tradeOptions.durationOptionsGoodForOneDay'),
  goodTillCancelled: i18next.t('miscScreens.tradeDisplay.tradeOrderLimitTillCancelled'),
  costBasis: i18next.t('common.costBasis'),
  stopLoss: i18next.t('miscScreens.tradeDisplay.tradeOrderStopLoss'),
  stopLimit: i18next.t('miscScreens.tradeDisplay.tradeOrderStopLimit'),
  stopPrice: i18next.t('miscScreens.tradeDisplay.tradeOrderStopPrice'),
  // ASC-16479: "Limit" display string keys below to be renamed to "Market-if-touched" (MIT)
  limitBuy: i18next.t('miscScreens.tradeDisplay.tradeOrderLimitBuy', {
    context: 'newline',
  }), // ASC-16479: Key to be renamed to MIT
  limitSell: i18next.t('miscScreens.tradeDisplay.tradeOrderLimitSell', {
    context: 'newline',
  }),
  limitPrice: i18next.t('miscScreens.tradeDisplay.tradeOrderLimitPrice'),
  limitOrder: i18next.t('miscScreens.tradeDisplay.tradeOrderLimitOrder'),
  marketBuy: i18next.t('common.marketBuy'),
  marketSell: i18next.t('common.marketSell'),
  buy: i18next.t('common.buy'),
  sell: i18next.t('common.sell'),
  transactionFee: i18next.t('common.transactionFee'),
  activityFee: i18next.t('miscScreens.tradeDisplay.tradeOrderActivityFee'),
  shares: i18next.t('common.share', { context: 'plural' }),
  estimatedShares: i18next.t('common.estimatedShares'),
  sharesQuantity: (count: number) => i18next.t('common.quantityValue', { context: 'share', count }),
  partialFillOfShares: i18next.t('miscScreens.activityHistory.popups.partialFillOfShares'),
  partialFillOfSharesValue: (accrued: number, remaining?: number) =>
    i18next.t('miscScreens.activityHistory.popups.partialFillOfSharesValue', {
      accrued,
      remaining,
    }),
  perShare: i18next.t('common.perShare'),
  amount: i18next.t('common.amount'),
  orderAmount: i18next.t('common.orderAmount'),
  estimatedOrderAmount: i18next.t('common.estimatedOrderAmount'),
  orderTotal: i18next.t('common.orderTotal'),
  estimatedOrderTotal: i18next.t('common.estimatedOrderTotal'),
  estimatedAmount: i18next.t('common.estimatedAmount'),
  orderBreakdown: i18next.t('common.orderBreakdown'),
  status: i18next.t('common.status'),
  frequency: i18next.t('common.frequency'),
  cancelNotAllowedNotice: i18next.t('miscScreens.activityHistory.popups.cancelNotAllowedNotice'),
};

export const statusDisplayStrings = {
  open: i18next.t('common.open'),
  cancelled: i18next.t('common.cancelled'),
  cancelling: i18next.t('common.cancelling'),
  pending: i18next.t('common.pending'),
  completed: i18next.t('common.completed'),
  returned: i18next.t('common.returned'),
};

export const transferDisplayStrings = {
  transferTitle: (context: 'deposit' | 'withdrawal' | 'returned') =>
    i18next.t('miscScreens.activityHistory.popups.transferTitle', { context }),
  automatedTransferTitle: (context: 'deposit' | 'withdrawal' | 'investment', security?: string) =>
    i18next.t('miscScreens.activityHistory.popups.automatedTransferTitle', { context, security }),
  deposit: i18next.t('common.deposit'),
  rollover: i18next.t('common.rollover'),
  automatedDeposit: i18next.t('common.automatedDeposit'),
  automatedWithdrawal: i18next.t('common.automatedWithdrawal'),
  automatedInvestment: i18next.t('common.automatedInvestment'),
  instantDeposit: i18next.t('common.instantDeposit'),
  threeDayDepositAmount: i18next.t('common.threeDayDepositAmount'),
  instantDepositAmount: i18next.t('common.instantDepositAmount'),
  withdrawal: i18next.t('common.withdrawal'),
  transferType: i18next.t('miscScreens.transfers.transferTypeTitle'),
  sector: i18next.t('miscScreens.common.sector'),
  symbol: i18next.t('common.symbol'),
  transferringFrom: i18next.t('miscScreens.activityHistory.popups.transferringFrom'),
  transferringTo: i18next.t('miscScreens.activityHistory.popups.transferringTo'),
  amount: i18next.t('common.amount'),
  totalAmount: i18next.t('common.totalAmount'),
  totalDepositAmount: i18next.t('common.depositAmount'),
  returnedTransfer: i18next.t('miscScreens.transfers.returnedTransfer'),
  returnedTransferFee: i18next.t('miscScreens.transfers.returnedTransferFee'),
  achTransfer: i18next.t('miscScreens.transfers.achTransfer'),
  ictTransfer: i18next.t('miscScreens.transfers.ictTransfer'),
  checkTransfer: i18next.t('miscScreens.transfers.checkTransfer'),
  depositBreakdown: i18next.t('miscScreens.transfers.depositBreakdown'),
  unknown: i18next.t('common.unknown'),
  instantDepositNotice: i18next.t('miscScreens.activityHistory.popups.instantDepositNotice'),
};

export const dividendDisplayStrings = {
  actionTypeValue: (subject: string, context: 'received' | 'reinvested') =>
    i18next.t('common.actionTypeValue', { subject, context }),
  transferType: i18next.t('miscScreens.transfers.transferTypeTitle'),
  automaticReinvestment: i18next.t('common.automaticReinvestment'),
  yes: i18next.t('common.yes'),
  security: i18next.t('common.security'),
  amount: i18next.t('common.amount'),
  sharesQuantity: (count: number) => i18next.t('common.quantityValue', { context: 'share', count }),
  unknown: i18next.t('common.unknown'),
  dividend: i18next.t('common.dividend'),
  dividendTypeValue: (context: 'cash' | 'stock' | 'qualified') =>
    i18next.t('common.dividendTypeValue', { context }),
  capitalGainsDistribution: i18next.t('common.capitalGainsDistribution'),
  returnOfCapitalDistribution: i18next.t('common.returnOfCapitalDistribution'),
};

export const interestDisplayStrings = {
  interestPaid: 'Interest paid',
  cashSweepProgram: 'Cash Sweep program',
  fpslProgram: 'FPSL program',
  transferType: 'Transfer type',
  amount: 'Amount',
  receivingFrom: 'Receiving from',
};

export const bondDisplayStrings = {
  distributionTitle: (security: string, context: 'maturity' | 'called') =>
    i18next.t('miscScreens.activityHistory.popups.bond.distributionTitle', { security, context }),
  tradeTitle: (security: string, type: string) =>
    i18next.t('miscScreens.activityHistory.popups.bond.tradeTitle', { security, type }),
  buyBond: i18next.t('common.buyBond'),
  sellBond: i18next.t('common.sellBond'),
  coupon: i18next.t('miscScreens.activityHistory.popups.bond.coupon'),
  cusip: i18next.t('miscScreens.activityHistory.popups.bond.cusip'),
  quantityOfBonds: i18next.t('miscScreens.activityHistory.popups.bond.quantityOfBonds'),
  principalAmount: i18next.t('miscScreens.activityHistory.popups.bond.principalAmount'),
  paymentPerBond: i18next.t('miscScreens.activityHistory.popups.bond.paymentPerBond'),
  total: i18next.t('miscScreens.activityHistory.popups.bond.total'),
};
